<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    </div>
    <b-card>
      <b-row>
        <b-col xl="6" md="6" sm="12">
          <span class="f-g">
            <h3>
              Promoção: {{tituloPromocao}} -
              {{dataInicialPromocao}} à {{dataFinalPromocao}}
            </h3>
          </span>
        </b-col>
        <b-col xl="6" md="6" sm="12">
          <div>
            <b-button
              variant="success"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              @click="atualizaPromocao"
            >
              <i class="fa fa-refresh fa-xl"></i>
              Atualizar itens
            </b-button>
            <b-button variant="danger" class="my-2 my-sm-0 w100 mr5" type="submit" @click="goBack">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col>
        <b-card>
          <b-table
            bordered
            hover
            v-if="produtos.length > 0"
            striped
            class="mb-0 pb-0"
            :items="produtos"
            :fields="fields_produtos"
            @row-clicked="rowHandle"
          >
            <template slot="img" slot-scope="data">
              <img v-if="data.item.img != -1" :src="data.item.img" alt="img" style="height: 32px;" />
              <span v-else>Sem imagem</span>
            </template>
            <template
              slot="valornormal"
              slot-scope="data"
            >R$ {{(data.item.valornormal).toLocaleString('pt-BR') }}</template>
            <template
              slot="valorpromocional"
              slot-scope="data"
            >R$ {{(data.item.valorpromocional).toLocaleString('pt-BR') }}</template>
            <template slot="destaque" slot-scope="data">
              <i v-if="data.item.destaque == 1" class="fa fa-star fa-lg"></i>
              <i v-else class="fa fa-star-o fa-lg"></i>
            </template>
          </b-table>
          <center class="text-center f-g" v-else>
            <i class="fa fa-frown-o fa-custom-size"></i>
            <h4>Desculpe, não encontramos nenhum produto :(</h4>
          </center>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref="modalOpcoes" size="md" centered hide-footer>
      <div slot="modal-header">
        <small>{{ codBarrasSelecionado }}</small> -
        <strong>{{ descricaoSelecionado }}</strong>
      </div>
      <b-row>
        <b-col cols="6" @click="destacarProduto(idSelecionado)">
          <b-col cols="12" class="centerModal">
            <i v-if="produtoDestacado" class="fa fa-star fa-custom-size" aria-hidden="true"></i>
            <i v-if="!produtoDestacado" class="fa fa-star-o fa-custom-size" aria-hidden="true"></i>
            <span v-if="produtoDestacado">
              Remover
              <br />destaque
            </span>
            <span v-if="!produtoDestacado">
              Destacar
              <br />produto
            </span>
          </b-col>
        </b-col>
        <b-col cols="6" @click="editarImagem(urlImagemSelecionada)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-file-image-o fa-custom-size" aria-hidden="true"></i>
            <span v-if="!urlImagemSelecionada">
              Vincular
              <br />Imagem
            </span>
            <span v-if="urlImagemSelecionada">
              Editar
              <br />Imagem
            </span>
          </b-col>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal centered ref="editarImagem" no-close-on-esc no-close-on-backdrop hide-header-close>
      <div slot="modal-header">
        <small>{{ codBarrasSelecionado }}</small> -
        <strong>{{ descricaoSelecionado }}</strong>
      </div>
      <template slot="modal-footer">
        <b-button @click="closeModal(true)" variant="secondary">Fechar</b-button>
        <b-button @click="newPhoto" variant="primary" :disabled="imagemSelecionado == null">Upload</b-button>
      </template>
      <div v-if="mostravel">
        <picture-input
          ref="pictureInput"
          width="300"
          height="300"
          margin="16"
          accept="image/jpeg, image/png"
          size="10"
          button-class="changeBtn"
          remove-button-class="removeBtn"
          :removable="false"
          :custom-strings="{
                          upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
                          drag: 'Arraste uma imagem <br> (ou clique aqui)',
                          change: 'Mudar foto',
                          remove: 'Remover foto'
                        }"
          @change="onChange"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";
import Loading from "vue-loading-overlay";

import PictureInput from "vue-picture-input";

export default {
  components: {
    Loading,
    PictureInput
  },
  data: _ => {
    return {
      isLoading: false,
      produtos: [],
      fields_produtos: [
        { key: "img", label: "Imagem" },
        { key: "destaque", label: "Destaque" },
        { key: "codbarras", label: "Cod Barras" },
        { key: "descricao", label: "Descrição" },
        { key: "valornormal", label: "Valor Normal" },
        { key: "valorpromocional", label: "Valor Promocional" }
      ],
      idPromocao: null,
      tituloPromocao: null,
      dataInicialPromocao: null,
      dataFinalPromocao: null,
      objPromocao: [],
      codBarrasSelecionado: null,
      descricaoSelecionado: null,
      urlImagemSelecionada: null,
      idSelecionado: null,
      produtoDestacado: false,
      isDestaque: null,
      imagemSelecionado: null,
      mostravel: false
    };
  },
  async beforeMount() {
    this.isLoading = true;
    this.objPromocao = JSON.parse(localStorage.getItem("promocaoSelecionada"));
    this.idPromocao = this.objPromocao.id;
    this.idPromocaoLocal = this.objPromocao.id_local;
    this.tituloPromocao = this.objPromocao.titulo;
    this.dataInicialPromocao = this.objPromocao.data_inicial;
    this.dataFinalPromocao = this.objPromocao.data_final;
    await this.receberProdutos();
    this.isLoading = false;
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async destacarProduto() {
      if (this.urlImagemSelecionada == -1) {
        this.$refs.modalOpcoes.hide();
        this.$dialogs
          .alert(
            `Este produto não possui imagem, atribua uma antes de destacar.`
          )
          .then(response => {
            this.$refs.modalOpcoes.show();
          });
      } else {
        await axios
          .post(
            `${config.default.servidor}/gerencial/promocao/item/destaque`,
            {
              id: this.idSelecionado,
              destaque: this.isDestaque
            },
            {
              headers: {
                Authorization: "Basic c2E6QURNQUNDRVNZUw=="
              }
            }
          )
          .then(async response => {
            this.isLoading = true;
            this.$refs.modalOpcoes.hide();
            await this.receberProdutos();
            let toast = this.$toasted.show(
              `Destaque ${this.isDestaque ? "removido" : "aplicado"}!`,
              {
                theme: "toasted-primary",
                position: "bottom-center",
                duration: 5000,
                icon: "check",
                iconPack: "fontawesome"
              }
            );
            this.isLoading = false;
          });
      }
    },
    async newPhoto() {
      if (this.imagemSelecionado == null) {
        this.closeModal(false);
        this.imagemSelecionado = null;
        this.$dialogs
          .alert("É necessário colocar uma imagem.", {
            title: "Aviso",
            size: "sm"
          })
          .then(res2 => {
            this.editarImagem();
          });
      } else {
        this.isLoading = true;
        const imagem = this.imagemSelecionado;
        const codBarras = this.codBarrasSelecionado;
        this.closeModal(false);
        await axios
          .post(
            `${config.default.servidor}/gerencial/promocao/item/imagem`,
            {
              empresaid: localStorage.getItem("enterprise_id").toString(),
              nomeDaImagem: codBarras,
              imagem: imagem
            },
            {
              headers: {
                Authorization: "Basic c2E6QURNQUNDRVNZUw=="
              }
            }
          )
          .then(async response => {
            if (response) {
              this.items = {};
              await this.receberProdutos();
            }
          })
          .catch(e => {
            alert(e);
          });
        this.isLoading = false;
      }
    },
    editarImagem() {
      this.$refs.modalOpcoes.hide();
      this.$refs.editarImagem.show();
      setTimeout(_ => {
        this.mostravel = true;
      }, 100);
    },
    onChange(image) {
      if (image) {
        this.imagemSelecionado = image;
      } else this.imagemSelecionado = null;
      console.info({ imagemSelecionado: this.imagemSelecionado });
    },
    closeModal(b) {
      this.imagemSelecionado = null;
      this.$refs.editarImagem.hide();
      this.mostravel = false;
      if (b) this.$refs.modalOpcoes.show();
    },
    rowHandle(record, index) {
      this.idSelecionado = record.id;
      this.codBarrasSelecionado = record.codbarras;
      this.descricaoSelecionado = record.descricao;
      this.urlImagemSelecionada = record.img;
      this.isDestaque = record = record.destaque;

      console.info({ codBarras: this.codBarrasSelecionado });

      if (this.isDestaque == 1) {
        this.produtoDestacado = true;
      } else {
        this.produtoDestacado = false;
      }

      this.$refs.modalOpcoes.show();
    },
    async atualizaPromocao() {
      await this.$dialogs
        .confirm(
          "Ao atualizar os itens da promoção, você perderá as configurações de destaque. Deseja continuar?",
          {
            title: "Aviso!",
            cancelLabel: "Cancelar",
            okLabel: "Sim"
          }
        )
        .then(async res => {
          if (res.ok == true) {
            this.isLoading = true;

            await axios
              .post(
                `${config.default.servidor}/gerencial/promocao/itens`,
                {
                  empresaid: localStorage.getItem("enterprise_id"),
                  promocaoid: this.idPromocaoLocal,
                  promocaowebid: this.idPromocao
                },
                {
                  headers: {
                    Authorization: "Basic c2E6QURNQUNDRVNZUw=="
                  }
                }
              )
              .then(async response => {
                if (!response.data.error) {
                  await this.receberProdutos();
                  let toast = this.$toasted.show("Itens atualizados!", {
                    theme: "toasted-primary",
                    position: "bottom-center",
                    duration: 5000,
                    icon: "check",
                    iconPack: "fontawesome"
                  });
                } else {
                  let toast = this.$toasted.show("Falha ao atualizar itens.", {
                    theme: "toasted-primary",
                    position: "bottom-center",
                    duration: 5000,
                    icon: "exclamation-triangle",
                    iconPack: "fontawesome"
                  });
                }
                this.isLoading = false;
              })
              .catch(error => {
                console.error(error);
              });
          }
        });
      this.isLoading = false;
    },
    async receberProdutos() {
      await axios
        .get(
          `${config.default.servidor}/gerencial/promocao/itens/web/${
            this.idPromocao
          }/${localStorage.getItem("enterprise_id")}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            this.produtos = response.data.data;
          }
        });
    }
  }
};
</script>